import { render, staticRenderFns } from "./WhatsApp.vue?vue&type=template&id=2ea444ba&scoped=true&"
var script = {}
import style0 from "./WhatsApp.vue?vue&type=style&index=0&id=2ea444ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea444ba",
  null
  
)

export default component.exports